import useTheme from "hooks/useTheme";

import Tooltip from "rc-tooltip";
import "rc-tooltip/assets/bootstrap_white.css";

const StyledTooltipWithoutArrow = (props) => {
	const { themeColor } = useTheme();

	return (
		<Tooltip
			animation="zoom"
			destroyTooltipOnHide={false}
			overlay={<div className={`text-xs font-medium text-white`}>{props.title}</div>}
			overlayStyle={{ backgroundColor: "transparent" }}
			overlayInnerStyle={{
				backgroundColor: themeColor?.hex,
				borderRadius: "10px",
				minHeight: "20px",
				padding: "6px 6px",
				border: "0px",
			}}
			showArrow={false}
			mouseEnterDelay={0.3}
		>
			{props?.children}
		</Tooltip>
	);
};

export default StyledTooltipWithoutArrow;
